<template>
<div class="contents">
    <div class="wrap">
        <section>
          <h2 class="page_title --view">약재상세 신규 등록</h2>
        </section>
        <section>
            <article>    
                <div class="table_list mb40">
                    <table class="write">
                        <colgroup>
                            <col width="25%">
                            <col width="25%">
                            <col width="25%">
                            <col width="25%">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th><span>약제코드</span></th>
                                <td>{{regData.medicineCd}}</td>
                                <th><span>약재명</span></th>
                                <td>{{regData.medicineNm}}</td>
                            </tr>    
                        </tbody>    
                    </table>
                </div>
             </article>    
        </section>
        <section>    
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <!-- <tr>
                  <th><span class="emp">약재상세명</span></th>
                  <td>                
                    <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.medHrbDtlNm">
                  </td>
                </tr>  -->
                <tr>
                  <th><span class="emp">원산지</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="regData.orgPlceCd">              
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in orgCodeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <th><span class="emp">g당 판매단가</span></th>
                  <td>                
                    <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.medSalePrc"><span>원</span>
                  </td>
                </tr> -->
                <tr>
                  <th><span>규격여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio_standard" value="Y" v-model="regData.standardYn">
                        <label for="radio1">규격</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio_standard" value="N" v-model="regData.standardYn">
                        <label for="radio2">비규격</label>
                      </div>
                    </div>                   
                  </td>
                </tr>        
                <tr>
                  <th><span class="emp">기준 약재 재고량</span></th>
                  <td>
                    <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.medStdrInvtQy"><span>g</span>
                  </td>
                </tr>          
                <tr>
                  <th><span class="emp">우선순위</span></th>
                  <td>
                    <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.rank">  
                    <span>※ 우선순위 0인 경우 추천처리</span>          
                  </td>
                </tr>
                <tr>
                  <th><span>사용유무</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio3" name="radio_use" value="Y" v-model="regData.useYn">
                        <label for="radio3">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio4" name="radio_use" value="N" v-model="regData.useYn">
                        <label for="radio4">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>  
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- button class="btn btn_md btn_gray">취소</button -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'MedicineMngtDtlReg',
    mixins: [commonUtil],
    async created(){
        //공통코드 - 원산지 가져오기
        this.orgCodeList = await this.getCode('GC00000001');
        this.regData.status = this.$store.getters['medicine/getStatus']; 

        if(this.regData.status == 'M'){
            this.regData.medHrbDtlSeq = this.$store.getters['medicine/getMedHrbDtlSeq']; 
            this.fn_search(); 
        }
    },  
    data() {
        return {
            regData : {
                medicineCd : this.$route.query.code,
                medicineNm : this.$route.query.codeNm,
                medHrbDtlSeq : '',
                medHrbDtlNm : '',
                orgPlceCd : null,
                medSalePrc : "",
                medStdrInvtQy : "",
                rank : '',
                standardYn : 'Y',
                useYn : 'Y',
                status : '',          
            },
            orgCodeList : []
        }
    },
    methods : {
        fn_reg(){

            //console.log("@@@@ regData : %o",this.regData);

                axios.post("/api/medicine/regMedicineDtl", 
                    this.regData
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
        },
        fn_move_page(){
            this.$router.push("/admin/medicine/medicineMngt");
        },
        fn_search(){

          let param = new Object();
          param.medicineCd = this.regData.medicineCd;
          param.medHrbDtlSeq = this.regData.medHrbDtlSeq;

          console.log("@@@@ param : %o",param);

          axios
              .post("/api/medicine/medicineDtlDetail", param)
              .then((res) => {
                  console.log("@@@@ dtl res : %o",res);
                  
                  //this.regData.medicineCd = res.data.med_hrb_cd;
                  //this.regData.medHrbDtlNm = res.data.med_hrb_dtl_nm;
                  this.regData.orgPlceCd = res.data.org_plce_cd;
                  this.regData.medSalePrc = res.data.med_sale_prc;
                  this.regData.medStdrInvtQy = res.data.med_stdr_invt_qy;
                  this.regData.rank = res.data.rank;
                  this.regData.useYn = res.data.use_yn;
                  this.regData.standardYn = res.data.standard_yn;
              })
              .catch((err) => console.log(err));
                
        },
    }
  }
</script>